import React from 'react'
import { useCallback, useState, useRef, useEffect, useMemo, RefObject } from 'react'
import { useNavigate, useParams, useSearchParams } from 'react-router-dom'
import { NavBar } from '../../../../components/layout/NavBar'
import './Registration.module.css'
import { Services } from '@/services/services'
import { Translates } from '@/services/repository/i18n'
import { SubmitHandler, useForm } from 'react-hook-form'
import { RegistrationForm, RegistrationFormData, FormErrors } from './Registration.form'
import { VerifyEmailFormData } from '../step1/VerifyEmail.form'
import { MainLayout } from '@/components/layout/MainLayout'
import { CommunalHeader } from '@/components/layout/CommunalHeader'

export const RegistrationPage = ({ services, data, token }: { services: Services, data: VerifyEmailFormData, token: string }) => {
  const navigate = useNavigate()
  // const [data, setData] = useState<RegistrationFormData>()
  const [translates, setTranslates] = useState<Translates>()
  const [message, setMessage] = useState<string>()
  const [serverErrors, setServerErrors] = useState<FormErrors<RegistrationFormData>>()

  const form = useForm<RegistrationFormData>({
    defaultValues: data
  })

  const onSubmit = async (data: RegistrationFormData, resetForm: () => void) => {
    setMessage(undefined)
    const resp = await fetch(`/api/schema/users/register/finish?token=${token}`, {
      method: 'POST',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(data)
    })
    if (!resp.ok) {
      setServerErrors(await resp.json())
    } else {
      services.session.loadUserSession(await resp.json())
      setMessage('page.registration.success')
      setTimeout(() => {
        navigate('/')
      }, 5000)
    }
  }

  useEffect(() => {
    services.i18n.get('main').then(setTranslates)
  }, [])


  if (translates === undefined) {
    return (<div className='spinner'></div>)
  }

  return <MainLayout services={services} translates={translates} pageName='registration'>
    <CommunalHeader services={services} translates={translates} pageId='registration' />
    <div className='main-form main-form-single-col main-form-single-col'>
      <div className='form-title'>{translates.for('page.registration.formTitle')}</div>
      {message ? (<div className='form-message'>{translates.for(message)}</div>) : <RegistrationForm
        form={form}
        services={services}
        onSubmit={onSubmit}
        serverErrors={serverErrors}
      />}
    </div>
  </MainLayout>
}
